import script from "./rec-print-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-print-button.vue?vue&type=script&lang=ts&setup=true"

import "./rec-print-button.vue?vue&type=style&index=0&id=0cf32980&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cf32980"]])

export default __exports__